import { Expose } from "class-transformer";

export class ValidateTimeOffDto {
  @Expose()
  timeOffId: string;

  @Expose()
  timeOffTypeId?: string;
}
